const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/store/userLinkage.ts';
import { createSelector } from 'reselect';
import { actionLoadIAMUserPatientLink, LOAD_IAM_USER_PATIENT_LINK } from 'App/actions/iam';
import { PatAppStoreState } from './setup/rootReducer';
import { getData, makeReducer2, useRemoteData2 } from '@cistec/common_web/utils/redux4Requests';
import { selectEmailFromRegisterWorkItem } from './login';
import { useSelector } from 'react-redux';

// REDUCER

export const userLinkageReducer = makeReducer2([[LOAD_IAM_USER_PATIENT_LINK]]);

// SELECTORS

const selectReducerState = (state: PatAppStoreState) => state.iamUserPatientLink;

const selectUserLinkage = createSelector([selectReducerState], state => getData(state));

const selectIsUserLinked = createSelector([selectUserLinkage], data => !!data && !!Object.keys(data));

// HOOKS

export const useUserLinked = () => {
    const email = useSelector(selectEmailFromRegisterWorkItem);

    return useRemoteData2('iamUserPatientLink', {
        shouldRequest: !!email,
        request: dispatch => dispatch(actionLoadIAMUserPatientLink()),
        select: selectIsUserLinked,
    });
};
